
// All state now lives in src/store.js — modules import { store } directly.
// This inline script only handles init calls that must run after all modules load.
import { store } from './src/store.js'

document.body.setAttribute('data-theme', store.currentTheme);
_setupLoginHandler();
loadTareas();
loadSettings();
importarLeadsFormulario();
checkExistingSession();
